import { ComponentType } from "react";
import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { LinkEditFakeComponent, LinkEditFakeComponentProps } from "../LinkEditFakeComponent";
import { FAKE_COMPONENT_VALUE_LOC_KEY } from "../locKeys";
import { FakeContainerProps } from "../types";

export type LinkEditFakeProps = FakeContainerProps;

type StateProps = Pick<LinkEditFakeComponentProps, "value" | "title" | "valueTitle" | "label">;

const mapStateToProps: MapStateToProps<StateProps, LinkEditFakeProps, IAppState> = (state, { locKey }) => ({
    value: getPrimaryText(state, FAKE_COMPONENT_VALUE_LOC_KEY) ?? "",
    valueTitle: getSecondaryText(state, FAKE_COMPONENT_VALUE_LOC_KEY) ?? "",
    label: getPrimaryText(state, locKey) ?? "",
    title: getSecondaryText(state, locKey) ?? "",
});

/**
 * Zajišťuje překlad lokalizačního klíče pro získání hodnoty zobrazované v LinkEditFakeComponent a také pro vysvětlivku (title).
 */
export const LinkEditFake: ComponentType<LinkEditFakeProps> = connect(mapStateToProps)(LinkEditFakeComponent);
